import { render, staticRenderFns } from "./nft.vue?vue&type=template&id=1a702311&scoped=true&"
import script from "./nft.vue?vue&type=script&lang=js&"
export * from "./nft.vue?vue&type=script&lang=js&"
import style0 from "./nft.vue?vue&type=style&index=0&id=1a702311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a702311",
  null
  
)

export default component.exports